export interface ShowingSlotLabelInput {
  scheduledAt: string | null;
  preferredDate: string | null;
  preferredTime: string | null;
}

export function formatShowingSlotLabel(args: ShowingSlotLabelInput): string {
  const scheduledAt = normalizeNonEmptyString(args.scheduledAt);
  if (scheduledAt !== null) {
    const parsed = Date.parse(scheduledAt);
    if (!Number.isNaN(parsed)) {
      return new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      }).format(new Date(parsed));
    }
  }

  const preferredDate = normalizeNonEmptyString(args.preferredDate);
  const preferredTime = normalizeNonEmptyString(args.preferredTime);
  if (preferredDate === null || preferredTime === null) {
    return 'Slot not set';
  }

  return `${formatDateLabel(preferredDate)} at ${formatTimeLabel(preferredTime)}`;
}

export function deriveShowingSlotTimestamp(args: ShowingSlotLabelInput): number | null {
  const scheduledAt = normalizeNonEmptyString(args.scheduledAt);
  if (scheduledAt !== null) {
    const parsed = Date.parse(scheduledAt);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }

  const preferredDate = normalizeNonEmptyString(args.preferredDate);
  const preferredTime = normalizeNonEmptyString(args.preferredTime);
  if (preferredDate !== null && preferredTime !== null) {
    const parsed = Date.parse(`${preferredDate}T${preferredTime}:00`);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }

  if (preferredDate !== null) {
    const parsed = Date.parse(preferredDate);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }

  return null;
}

function normalizeNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function formatDateLabel(value: string): string {
  const parsed = Date.parse(value);
  if (Number.isNaN(parsed)) {
    return value;
  }
  return new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(parsed));
}

function formatTimeLabel(value: string): string {
  const [hourString, minuteString] = value.split(':');
  const hour = Number(hourString);
  const minute = typeof minuteString === 'string' && minuteString.length > 0 ? minuteString : '00';

  if (Number.isNaN(hour)) return value;

  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12.toString()}:${minute.padStart(2, '0')} ${period}`;
}
